import { useCallback } from "react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
  DropdownMenuPortal,
  DropdownMenuItem,
  DropdownMenuCheckboxItem,
} from "~/components/shared/DropdownMenu";
import Icon from "~/components/shared/Icon";
import { useBuildPreferencesStore } from "~/components/build/Show/lib/useBuildPreferencesStore";

export function TableActionsDropdown() {
  const resetColumnWidths = useBuildPreferencesStore((state) => state.resetColumnWidths);
  const showRetriedJobs = useBuildPreferencesStore((state) => state.showRetriedJobs);
  const setShowRetriedJobs = useBuildPreferencesStore((state) => state.setShowRetriedJobs);

  const handleToggleRetriedJobs = useCallback(() => {
    setShowRetriedJobs(!showRetriedJobs);
  }, [showRetriedJobs, setShowRetriedJobs]);

  const preventClose = useCallback((event: Event) => {
    event.preventDefault();
  }, []);

  return (
    <div className="ml-auto flex">
      <DropdownMenu>
        <DropdownMenuTrigger asChild={true}>
          <button
            className="-mr-0.5 flex items-center rounded-md p-0.5 hover:bg-purple-100 hover:text-purple-600"
            data-testid="table-actions-dropdown"
          >
            <Icon icon="heroicons/solid/ellipsis-vertical" className="h-5 w-5" />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuPortal>
          <DropdownMenuContent>
            {Features.BuildTableHideRetriedJobs && (
              <DropdownMenuCheckboxItem
                checked={showRetriedJobs}
                onClick={handleToggleRetriedJobs}
                onSelect={preventClose}
                className="!text-charcoal-700 !bg-transparent !font-medium data-[highlighted]:!bg-gray-100 data-[highlighted]:!text-purple-600"
              >
                Show retried jobs
              </DropdownMenuCheckboxItem>
            )}

            <DropdownMenuItem onClick={resetColumnWidths}>Reset all column widths</DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenuPortal>
      </DropdownMenu>
    </div>
  );
}
